import Vue        from 'vue'
import VueRouter  from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'test',
    component: () => import(/* webpackChunkName: "postVenta" */ '@/views/test'),
  },
  {
    path: '/arbol/:pedido',
    name: 'arbol',
    component: () => import(/* webpackChunkName: "postVenta" */ '@/views/arbol'),
  },
  {
    path: '/reclamo/:pedido',
    name: 'reclamo',
    component: () => import(/* webpackChunkName: "postVenta" */ '@/views/postVenta'),
  },
  {
    path: '/detalle/:pedido',
    name: 'detalle',
    component: () => import(/* webpackChunkName: "postVenta" */ '@/views/detallePedido'),
  },
  {
    path: '/ayuda/:pedido',
    name: 'ayuda',
    component: () => import(/* webpackChunkName: "postVenta" */ '@/views/postVenta'),
  },
  //? View que se mostrara en webcentrix
  {
    path: '/webcentrix/:pedido',
    name: 'webcentrix',
    component: () => import(/* webpackChunkName: "webcentrix" */ '../views/WebCentrix'),
    props: ( route ) => {
      const { pedido } =  route.params;
      return pedido.trim().length > 0 ? { pedido } : { pedido: 0 }
    }
  },
  {
    path: '*',
    name:"not-found",
    component: () => import(/* webpackChunkName: "about" */ '../views/404.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 1 };
  },
})

export default router
